import { createSlice } from '@reduxjs/toolkit'

const LS_KEY = 'BLP_UI_STATE'

const DEFAULT_UI_STATE = {
  isOpenFilter: false,
  searchValue: '',
  activeTab: 'List',
  onlyMeComprador: false,
  categoryFilterValue: 'All',
  statusFilterValue: 'All',
  pavilionFilterValue: 'All',
  startDate: null,
  endDate: null,
  sortData: { field: 'name', direction: 'asc' },
}

const DEFAULT_STATE = {
  ...DEFAULT_UI_STATE,
  ui: {
    hideImage: false,
    showCheckbox: true,
    openAccardions: true,
    groupByProveedor: false,
  },
}

const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem(LS_KEY)
    if (serializedState === null) {
      return DEFAULT_STATE
    }
    const persistedUiState = JSON.parse(serializedState)

    // Объединяем дефолтное состояние с загруженным UI-состоянием
    return {
      ...DEFAULT_STATE,
      ui: {
        ...persistedUiState,
      },
    }
  } catch (e) {
    console.warn(
      'Ошибка загрузки UI-состояния из localStorage:',
      e,
    )
    return DEFAULT_STATE
  }
}

const initialState = {
  isOpenFilter: false,
  searchValue: '',
  activeTab: 'List',
  onlyMeComprador: false,
  categoryFilterValue: 'All',
  statusFilterValue: 'All',
  pavilionFilterValue: 'All',
  startDate: null,
  endDate: null,
  sortData: { field: 'name', direction: 'asc' },
}

export const BLPSlice = createSlice({
  name: 'BLP',
  initialState: loadStateFromLocalStorage(),
  reducers: {
    setIsOpenFilter: (state, action) => {
      state.isOpenFilter = action.payload
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setOnlyMeComprador: (state, action) => {
      state.onlyMeComprador = action.payload
    },
    setCategoryFilterValue: (state, action) => {
      state.categoryFilterValue = action.payload
    },
    setStatusFilterValue: (state, action) => {
      state.statusFilterValue = action.payload
    },
    setPavilionFilterValue: (state, action) => {
      state.pavilionFilterValue = action.payload
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload
    },
    setSortData: (state, action) => {
      state.sortData = action.payload
    },
    setAllUiFilters: (state, action) => {
      state.ui = { ...state.ui, ...action.payload };
    }
  },
})

export const {
  setIsOpenFilter,
  setSearchValue,
  setActiveTab,
  setOnlyMeComprador,
  setCategoryFilterValue,
  setStatusFilterValue,
  setPavilionFilterValue,
  setStartDate,
  setEndDate,
  setSortData,
  setAllUiFilters,
} = BLPSlice.actions
export default BLPSlice.reducer
